import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('purchase_order_matching'),
    buttonLearnMore: defineMessage('learn_more'),
    sectionManualTitle: defineMessage('enable_the_manual_matching_to_purchase_orders'),
    optionManual: defineMessage('allow_users_to_match_bills_to_purchase_orders'),
    sectionNotMatchedApproveTitle: defineMessage('can_a_bill_be_approved__hed_to_a_purchase_order'),
    optionNotMatchedApproveYes: defineMessage('yes_unmatched_bills_can_be_approved'),
    optionNotMatchedApproveYesAmount: defineMessage('yes_unmatched_bills_up___amount_can_be_approved'),
    optionNotMatchedApproveNo: defineMessage('no_unmatched_bills_cannot_be_approved'),
    sectionOverbudgetTitle: defineMessage('can_a_bill_be_approved__ase_order_is_below_zero'),
    optionOverbudgetYes: defineMessage('yes_such_bills_can_be_approved'),
    optionOverbudgetYesPercent: defineMessage('yes_such_bills_can_be_a_alance_is_not_more_than'),
    optionOverbudgetYesAmount: defineMessage('yes_such_bills_can_be_a_alance_is_not_more_than'),
    optionOverbudgetNo: defineMessage('no_such_bills_cannot_be_approved'),
    sectionRetrospectiveTitle: defineMessage('can_a_bill_be_matched_t__which_has_a_later_date'),
    optionRetrospectiveYes: defineMessage('yes_allow_matching_bill_pective_purchase_orders'),
    optionRetrospectiveNo: defineMessage('no_do_not_allow_matchin_pective_purchase_orders'),
    sectionAmountTypeTitle: defineMessage('which_type_of_amounts_s_he_matching_allocations'),
    sectionAmountTypeWarning: defineMessage('changing_this_setting_w__all_remaining_balances'),
    sectionAmountTypeWarningBold: defineMessage('you_can_only_change_this_setting_once_every_hours'),
    optionAmountTypeGross: defineMessage('gross_amounts'),
    optionAmountTypeNet: defineMessage('net_amounts'),
    sectionInsufficientBudgetTitle: defineMessage('can_a_bill_be_approved__ng_the_netgross_setting'),
    optionInsufficientBudgetAlways: defineMessage('yes_such_bill_can_be_approved'),
    optionInsufficientBudgetWithThreshold: defineMessage('yes_allocated_amount_is_to_the_following_amount'),
    optionInsufficientBudgetWithPercentageThreshold: defineMessage('yes_the_bill_can_be_app_tal_amount_is_less_than'),
    optionInsufficientBudgetNever: defineMessage('no_the_bill_cant_be_app_s_than_its_total_amount'),
    sectionAddMatchedPOsRequestersTitle: defineMessage('should_the_requester_of_he_active_approval_step'),
    optionAddMatchedPOsRequestersNone: defineMessage('no'),
    optionAddMatchedPOsRequestersManually: defineMessage('yes_display_a_list_of_requesters_to_be_added'),
    optionAddMatchedPOsRequestersAll: defineMessage('yes_automatically_add_a_equesters_if_applicable'),
    percent: defineMessage('percent'),
    percentBelowXero: defineMessage('percent_below_zero'),
    belowZero: defineMessage('below_zero'),
    warning: defineMessage('changing_this_setting_w_etting_once_every_hours'),
};
